import classNames from "classnames";

import AscButton from "../../AscButton/AscButton";
import { CheckActiveIcon } from "../../AscIcons";
import AscTag from "../../AscTag/AscTag";
import AscHeading from "../../AscTypography/AscHeading/AscHeading";
import styles from "./AscPricingCard.module.scss";
import { useResponsive } from "libs/components/src/lib";

export interface AscPricingCardProps {
  className?: string;
  title: string;
  percentSaved?: string;
  price: number;
  planDurationType?: "month" | "year";
  description: string;
  features: { name: string }[];
  onGetStarted: () => void;
  onSelect?: () => void;
  type?: string;
  actionBtnText?: string;
  actionButtonDisabled?: boolean;
  actionButtonVariant?: "primary" | "secondary";
  isActive?: boolean;
}

export default function AscPricingCard({
  className,
  title,
  percentSaved,
  price,
  planDurationType = "month",
  description,
  features,
  onGetStarted,
  onSelect,
  type = "basic",
  actionBtnText = "Get Started",
  actionButtonDisabled = false,
  actionButtonVariant = "primary",
  isActive = false,
}: AscPricingCardProps) {
  const { isLarge } = useResponsive();
  return (
    <div
      data-testid="asc-pricing-card"
      className={classNames(
        styles.ground,
        {
          [styles.basic]:
            type?.includes("Explorer") ||
            type?.includes("Voyager") ||
            (!isLarge && type.includes("Navigator")),
          [styles.professional]: isLarge && type.includes("Navigator"),
          [styles.active]: isLarge && isActive,
        },
        className
      )}
      onClick={onSelect}
    >
      <div className={styles.topContent}>
        <AscHeading className={styles.title} level={4}>
          {title}
        </AscHeading>
        {percentSaved && (
          <AscTag
            className={styles.percentSaved}
            label={`Save ${percentSaved}%`}
          />
        )}
        <div className={styles.mobilePrice}>
          <span className={styles.mobilePriceText}>{price} $</span> /{" "}
          {planDurationType}
        </div>
      </div>
      <div className={styles.price}>
        <span className={styles.priceText}>{price} $</span> / {planDurationType}
      </div>
      <div className={styles.description}>{description}</div>
      <ul className={styles.featuresList}>
        {features.map((feature, index) => (
          <li className={styles.feature} key={index}>
            <CheckActiveIcon className={styles.featureIcon} />
            <span className={styles.featureText}>{feature.name}</span>
          </li>
        ))}
      </ul>
      <AscButton
        disabled={actionButtonDisabled}
        variant={actionButtonVariant}
        onClick={onGetStarted}
        className={styles.ctaButton}
      >
        {actionBtnText}
      </AscButton>
    </div>
  );
}
